import { PersonalModel } from '../../../../user';

export const getUserName = (personal: PersonalModel): string =>
  `${personal.firstName} ${personal.lastName}`.trim();
